import { useTenants } from "@sg-protect/shell";

// A project can sit on the primary tenant without being a migrate-assessment tenant. A tenant in neither list is not
// linked to the workspace, so it is not consented.
export function useIsTenantConsented(tenantId: string | null | undefined): boolean {
    const { tenants } = useTenants();

    if (!tenantId || !tenants) {
        return false;
    }

    const migrateTenant = tenants.migrateAssessmentTenants.find(tenant => tenant.id === tenantId);

    if (migrateTenant) {
        return migrateTenant.isConsented;
    }

    return tenants.primaryTenant?.id === tenantId && tenants.primaryTenant.isConsented;
}
